export default {
    // 验证手机号
	verifyMobile(mobile){
		console.log(mobile)
		var mreg = /^1[3456789][0-9]\d{8}$/;
		// var mreg = /(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{6,16}/;
		if (!mobile) {
			return false;
		}
		if (!mreg.test(mobile)) {
			return false;
		}
		return true;
	},
// 验证密码
	verifyPass(password) {
		var preg = /(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{6,16}/
		if (!(preg.test(password))) {
			// alert('请输入6-12位数字字母组合密码!')
			return;
		}
		return true;
	},
	verifyCode(code) {
		var creg = /^\d{6}$/
		if (!(creg.test(code))) {
			// alert('请输入6-12位数字字母组合密码!')
			return;
		}
		return true;
	},

}